import Film from './Film'

export default Film
// eslint-disable-next-line import/export
export * from './Film'
